import { NgModule } from '@angular/core';
import { AuthGuard } from '../auth/auth.guard';
import { ModalsModule } from '../modals/modals.module';
import { CommonModule } from '@angular/common';
import { EmailService } from './email.service';
import { PluginsService } from '../plugins/plugins.service';
import { CustomizationService } from '../customization/customization.service';
import { EmailComponent } from './email.component';
import { EmailEditorComponent } from './editor/editor.component';
import { EmailEditorComponent2 } from './editor-2/editor.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxEditorModule } from 'ngx-editor';
import { FormsModule } from '@angular/forms';
import { TagEditorModule } from '../tag-editor/tag-editor.module';
import { TagsFormatService } from '../tags/tags-format.service';
import { ValidateImportService } from './editor/validate.import.service';
import { BlockHeaderComponent } from '../block-header/block-header.component'
import { SimpleFileUploadComponent } from '../sessions/file-upload/simple-file-upload.component'
import { FileUploadModule } from 'ng2-file-upload';
import { DatePickerModule } from '../date-picker/date-picker.module';

@NgModule({
  declarations: [EmailComponent, EmailEditorComponent, EmailEditorComponent2, BlockHeaderComponent, SimpleFileUploadComponent],
  exports: [EmailComponent, EmailEditorComponent],
  imports: [CommonModule, TranslateModule, FormsModule, NgxEditorModule, ModalsModule, TagEditorModule, FileUploadModule, DatePickerModule],
  providers: [AuthGuard, EmailService, CustomizationService, TagsFormatService, PluginsService, ValidateImportService],
  entryComponents: []
})
export class EmailModule {}



// WEBPACK FOOTER //
// ./src/app/modules/email/email.module.ts